import { debouncer, documentReady, slideUp, slideDown, getNextSibling, getPrevSibling } from "../Utility/utils";
import {gsap} from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

document.addEventListener('pageloaded', () => {
  // GSAP ScrollTrigger to animated image scale on scroll
  const scrollTriggerEls = document.querySelectorAll('.scaledImg, .hero__img.featured_img img');
  if(scrollTriggerEls){
    scrollTriggerEls.forEach(elem => {
      // Check for data-add-class to see if any additional classes need to be added when triggered
      const datalimit = elem.getAttribute('data-scale-limit');
      let limit;
      if(elem.classList.contains('attachment-post-thumbnail')){
        limit = 0.4;
      } else {
        limit = datalimit ? datalimit : 0.8;
      }

      ScrollTrigger.create({
        trigger: elem,
        // scroller: '#scroll-container',
        onUpdate: function(self){
          const progress = self.progress;
          const scale = 1 + (limit * progress);
          elem.style.setProperty('--image-scale', scale);
        }
      });
    });
  }
  
  setTimeout(function(){
    ScrollTrigger.refresh();
  }, 500);

  // update scroll on ui change
  const uiElements = document.querySelectorAll('.sd-accordion-header, .post_accordion__trigger');
  if(uiElements){
    uiElements.forEach(el => {
      el.addEventListener('click', function(){
        setTimeout(function(){
          ScrollTrigger.refresh();
        }, 500);
      });
    });
  }
});
